import { useState } from "react";
import { Outlet } from "react-router-dom";

import { mobileNavbarItems } from "../lib/constants";
import Footer from "./Dashboard/Footer";
import Header from "./Dashboard/Header";
import Sidebar from "./Dashboard/Sidebar";
import MobileSidebar from "./mobile/MobileSidebar";

const Dashboard = () => {
  const [openNotice, setOpenNotice] = useState(false);

  const handleopenNtification = (event) => {
    if (event.target.id === "BG" || event.target.id === "Button") {
      setOpenNotice(!openNotice);
    }
  };

  return (
    <div className="w-screen  max-w-screen h-[100dvh] max-h-[100dvh] bg-primary-50 flex flex-col md:p-4">
      <Header openNotice={openNotice} handleopenNtification={(event) => handleopenNtification(event)} />
      <div className=" h-full flex-1 flex w-full  md:rounded-xl   gap-[10px]   bg-white overflow-hidden p-1  ">
        <div className="hidden md:block">
          <Sidebar isFirstTime={true} />
        </div>
        <div className="flex-grow h-full max-h-full  overflow-scroll no-scrollbar md:flex justify-start items-start  md:rounded-v-2xl  bg-neutral-10   md:pt-0 md:pb-0   ">
          <Outlet />
        </div>
      </div>
      <div className=" sticky bottom-0 flex md:hidden w-full z-[9999]    ">
        <MobileSidebar sidebaritems={mobileNavbarItems} />
      </div>

      <Footer />
    </div>
  );
};

export default Dashboard;
